import { AssetCard } from './AssetCard';

const ToolTipCard = ({ asset }) => {
  return (
    <AssetCard asset={asset} />
  );
};

export default ToolTipCard;
